import { createSelector } from 'reselect';
// using reselect for memoized selectors

// selector
export const itemsSelector = state => state.dataFiltered;
export const allItemsSelector = state => state.data;
export const itemsCountSelector = state => state.dataFiltered.length;
export const sortSelector = state => state.sort;
export const currentPageSelector = state => state.currentPage;

export const tagsSelector = state => state.activeOptions;
export const rangeSelector = state => state.dateRange;
export const rangeMinSelector = state => state.dataRangeMin;
export const rangeMaxSelector = state => state.dataRangeMax;


function sortAndFilterItems(items, sort, tags, rangeMin, rangeMax, range) {
	var filtered = [...items];

	if (Object.keys(tags).length) { // selected filters / options 

		Object.keys(tags).forEach(function (key) {
			if (tags[key] && tags[key].length) {
				tags[key].forEach(function (optionKey) {
					let selected = Number(optionKey);
					if (key === 'f' || key === 'c') {
						filtered = filtered.filter(item => {
							return (item[key] === selected);
						});
					} else {
						filtered = filtered.filter(item => {
							return (item[key] && item[key].length && item[key].indexOf(selected) >= 0);
						});
					}

				});
			}
		});

	}

	if (range.min !== rangeMin || range.max !== rangeMax) { // selected date range
		filtered = filtered.filter(item => {
			//return (item.rd >= Number(range.min + '0101') && item.rd <= Number(range.max + '1231'));
			return (item.ys >= Number(range.min) && item.ys <= Number(range.max)) || (item.ye >= Number(range.min) && item.ye <= Number(range.max));
		});
	}

	switch (sort) {
		default:
		case 'releasedate':
			filtered.sort(function (a, b) {
				return Number(b.rd) - Number(a.rd);
				//return new Date(b.rd) - new Date(a.rd); 
			});
			break;

		case 'title':
			filtered.sort(function (a, b) {
				return a.t.localeCompare(b.t);
			});
			break;

	}
	//console.log(filtered);
	return filtered;
}

function getMin(items) {
	let min = items[0].ys;
	items.forEach((p)=>{
		if ( p.ys != 0 ) {
			if ( p.ys < min ) {
				min = p.ys;
			}
		}
	});
	return min ? min : 0;
}
function getMax(items) {
	let max = items.reduce((max, p) => p.ye > max ? p.ye : max, items[0].ye);
	return max ? max : 0;
}


// reselect function
export const getItems = createSelector(
	[itemsSelector],
	items => items
)


export const getItemsListOrdered = createSelector(
	[allItemsSelector, sortSelector, tagsSelector, rangeMinSelector, rangeMaxSelector, rangeSelector],
	(items, sort, tags, rangeMin, rangeMax, range) => sortAndFilterItems(items, sort, tags, rangeMin, rangeMax, range)
)

export const getItemsCount = createSelector(
	[itemsCountSelector],
	(count) => count
)

export const getCurrentPage = createSelector(
	[currentPageSelector],
	(page) => page
)

/* min max */
export const getReleasedFrom = createSelector(
	[allItemsSelector],
	(items) => getMin(items)
)

export const getReleasedTo = createSelector(
	[allItemsSelector],
	(items) => getMax(items)
)

